<template>
  <div :class="{'is-active': showModal}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="modal-title"></div>
      <div class="modal-content-box">
        <div class="confirmation-title-bar">Are you sure?</div>
        <div class="modal-content-wrapper">
          <div class="field">
            <p>{{derivedMessage()}}</p>
          </div>
          <div class="has-text-centered">
              <div class="xxlevel-item">
                <button @click="onYes"
                  class="button is-primary">
                  Confirm
                </button>
              </div>
              <p class="bail-out-message">
                <a href='#' @click="onNo">Cancel</a>
              </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AreYouSure',
  emits: ['yes', 'no'],
  data() {
    return {};
  },
  methods: {
    onNo() {
      this.$emit('no');
    },
    onYes() {
      this.$emit('yes');
    },
    derivedMessage() {
      const defaultMessage = 'Are you sure you want to do this?  If you select Yes, it cannot be undone.';
      return this.message && this.message.length > 0 ? this.message : defaultMessage;
    },
  },
  computed: {},
  props: {
    message: String,
    showModal: Boolean,
  },
};

</script>

<style scoped>
button {
  margin-top: 30px;
  min-width: 100%;
  border-radius: 8px;
}
.modal-background {
  opacity: 0.75;
}
.modal-content {
  max-width: 500px;
}
.modal-content-box {
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0 0 8px 0 rgba(0,0,0,0.21);
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.modal-content-wrapper {
  padding: 25px 25px;
}
.confirmation-title-bar {
  background-color: #FBBB00;
  color: #0F3D80;
  font-size: 18px;
  font-weight: bold;
  min-height: 30px;
  padding-left: 18px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.bail-out-message {
  margin-top: 15px;
}

</style>
